import { useRouteLoaderData } from 'react-router-dom';
import { styled } from 'styled-components';
import Toolbar from 'components/home/Toolbar';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
`;

/**
 * Home
 *
 * @returns {JSX.Element} - the homepage component
 */
export default function Home() {
  const { portfolios, user } = useRouteLoaderData('root');
  if (!user.is_superuser) {
    return null;
  }
  return (
    <Wrapper>
      <Toolbar portfolios={portfolios} user={user} />
    </Wrapper>
  );
}
